/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Style_Preset_DeletedInputs */

const en_image_export_style_preset_deleted = /** @type {(inputs: Image_Export_Style_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset deleted successfully`)
};

const fr_image_export_style_preset_deleted = /** @type {(inputs: Image_Export_Style_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prereglage supprime avec succes`)
};

const de_image_export_style_preset_deleted = /** @type {(inputs: Image_Export_Style_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellung erfolgreich gelöscht`)
};

const it_image_export_style_preset_deleted = /** @type {(inputs: Image_Export_Style_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preimpostazione eliminata con successo`)
};

const ru_image_export_style_preset_deleted = /** @type {(inputs: Image_Export_Style_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительно настроенные параметры успешно удалены.`)
};

const es_image_export_style_preset_deleted = /** @type {(inputs: Image_Export_Style_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preajuste eliminado exitosamente`)
};

const zh_cn2_image_export_style_preset_deleted = /** @type {(inputs: Image_Export_Style_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预设已成功删除`)
};

const ja_image_export_style_preset_deleted = /** @type {(inputs: Image_Export_Style_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットが正常に削除されました`)
};

const hi_image_export_style_preset_deleted = /** @type {(inputs: Image_Export_Style_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट सफलतापूर्वक हटा दिया गया`)
};

const pt_pt2_image_export_style_preset_deleted = /** @type {(inputs: Image_Export_Style_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinição excluída com sucesso`)
};

/**
* | output |
* | --- |
* | "Preset deleted successfully" |
*
* @param {Image_Export_Style_Preset_DeletedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_preset_deleted = /** @type {((inputs?: Image_Export_Style_Preset_DeletedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Preset_DeletedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_style_preset_deleted(inputs)
	if (locale === "de") return de_image_export_style_preset_deleted(inputs)
	if (locale === "it") return it_image_export_style_preset_deleted(inputs)
	if (locale === "ru") return ru_image_export_style_preset_deleted(inputs)
	if (locale === "es") return es_image_export_style_preset_deleted(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_style_preset_deleted(inputs)
	if (locale === "ja") return ja_image_export_style_preset_deleted(inputs)
	if (locale === "hi") return hi_image_export_style_preset_deleted(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_style_preset_deleted(inputs)
	return en_image_export_style_preset_deleted(inputs)
});